import { type ButtonBaseActions, Checkbox } from '@mui/material'
import { forwardRef, useImperativeHandle, useRef } from 'react'

// A Checkbox component that exposes a focus method that shows the focus visible state on it.
// By default the MUI Radio does not show the focus visible state when focused programmatically.
const FocusVisibleCheckboxBase = (
	props: Omit<React.ComponentProps<typeof Checkbox>, 'action' | 'inputRef'>,
	ref: React.Ref<HTMLButtonElement>
) => {
	const actionRef = useRef<ButtonBaseActions>(null)
	const checkboxRef = useRef<HTMLButtonElement>(null)
	useImperativeHandle(
		ref,
		() => ({
			...(checkboxRef.current as HTMLButtonElement),
			focus: () => {
				checkboxRef.current?.focus()
				actionRef.current?.focusVisible()
				checkboxRef.current?.scrollIntoView({
					behavior: 'smooth',
					block: 'center',
				})
			},
		}),
		[]
	)
	return <Checkbox {...props} action={actionRef} ref={checkboxRef} />
}
const FocusVisibleCheckbox = forwardRef(FocusVisibleCheckboxBase)

export { FocusVisibleCheckbox }
